module.exports = __webpack_public_path__ + "static/media/thesis.7263dc5e.pdf";